module.exports = __webpack_public_path__ + "img/NAMA.a032d1f4.svg";